/**
 * Created by Denis Kuzin on 05 april 2022
 */

const ClanMessageRow = cc.Node.extend({
    ctor: function (message) {
        this._super();
        this.message = message;

        const styles = cleverapps.styles.ClanMessageRow;
        const phrase = this.message.getText();

        const messageNode = this.messageNode = new cc.Node();
        messageNode.setAnchorPoint(0.5, 0.5);

        const messageTitle = this.createTitle(this.message.getPlayerAvatar(), this.message.getPlayerName(), this.message.type);

        let content;

        if (this.message.isHelpMessage()) {
            if (this.message.isUserMessage()) {
                content = this.createContentToReceiveHelp();
            } else {
                content = this.createContentToSendHelp();
            }
        } else if (this.message.isGiftMessage()) {
            if (this.message.isUserMessage()) {
                content = this.createContentAboutSentGift();
            } else {
                content = this.createContentToGetGift();
            }
        } else {
            content = cleverapps.UI.generateOnlyText(Messages.get(phrase), this.message.isUserMessage() ? cleverapps.styles.FONTS.CLAN_CHAT_PHRASE : cleverapps.styles.FONTS.CLAN_CHAT_TEAMMATE_PHRASE);
        }

        this.updateHelp(true);
        this.updateGift();

        let width = styles.helpRowWidth;
        if (!this.message.isHelpMessage()) {
            width = styles.maxRowWidth;
            const maxWidth = Math.max(content.width, messageTitle.width) + styles.deltaWidth;
            if (maxWidth < width) {
                width = maxWidth;
            }
        }

        const messageTitleBg = cleverapps.UI.createScale9Sprite(
            this.message.isHelpMessage() || this.message.isGiftMessage()
                ? bundles.my_clan_window.frames.massage_green_title_bg
                : bundles.my_clan_window.frames.massage_blue_title_bg,
            cleverapps.UI.Scale9Rect.TwoPixelXY
        );
        messageTitleBg.setContentSize2(width, styles.title.bg.height);
        messageTitleBg.setAlignment(styles.title.bg);
        messageNode.addChild(messageTitleBg, 1);

        messageTitle.setAlignment(styles.title);
        messageTitleBg.addChild(messageTitle);

        if (this.message.isHelpMessage() || this.message.isGiftMessage()) {
            let timeLeft = this.message.getTimeLeft();
            if (timeLeft > 0) {
                timeLeft = new cleverapps.CountDown(timeLeft, {
                    onFinish: function () {
                        cleverapps.clanMessages.onMessagesUpdated();
                    }
                });
            }

            const timer = new cleverapps.CountDownView(timeLeft, {
                font: cleverapps.styles.FONTS.CLANS_CHAT_TIMER_TEXT
            });
            messageTitleBg.addChild(timer);
            timer.setAlignment(styles.title.timer);
        }

        const messageContentBg = cleverapps.UI.createScale9Sprite(bundles.my_clan_window.frames[this.message.isUserMessage() ? "massage_content_orange_bg" : "massage_content_bg"], cleverapps.UI.Scale9Rect.TwoPixelXY);
        messageContentBg.setContentSize2(width, content.height + styles.content.bg.paddingY);
        messageContentBg.setAlignment(styles.content.bg);
        messageNode.addChild(messageContentBg);

        cleverapps.UI.fitToBox(content, {
            width: messageContentBg.width - styles.deltaWidth
        });
        messageContentBg.addChild(content);
        content.setAlignment(phrase ? styles.phrase : styles.content);

        cleverapps.UI.wrap(messageNode);

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(styles.width, messageNode.height);
        this.addChild(messageNode);
        if (this.message.isUserMessage()) {
            messageNode.setAnchorPoint(1, 0);
            messageNode.setAlignment(styles.right);
        } else {
            messageNode.setAnchorPoint(0, 0);
            messageNode.setAlignment(styles.left);
        }

        this.addArrow(messageNode);

        this.message.onHelpUpdated = this.createListener(this.updateHelp.bind(this));
        this.message.onGiftUpdated = this.createListener(this.updateGift.bind(this));
        this.message.onMessagePosted = this.createListener(this.received.bind(this));

        if (this.message.isFresh()) {
            this.messageNode.setCascadeOpacityEnabledRecursively(true);
            this.messageNode.setOpacity(160);
            this.messageNode.setScale(0);
            this.messageNode.runAction(new cc.ScaleTo(0.3, 1).easing(cc.easeBackOut()));
        }
    },

    received: function () {
        this.messageNode.runAction(new cc.FadeTo(0.15, 255));
    },

    updateHelp: function (silent) {
        if (this.message.isHelpMessage()) {
            this.updateProgressBar(silent);

            if (!this.message.isUserMessage()) {
                if (this.message.canHelp()) {
                    this.sendHelpButton.enable();
                } else {
                    this.sendHelpButton.disable();
                }
            } else {
                this.helpButtons.forEach((button) => {
                    if (button.help.status === ClansConfig.HELP_READY) {
                        button.enable();
                    } else {
                        button.disable();
                    }
                });
            }
            cleverapps.toolbar.resetByType(ToolbarItem.CLANS);
        }
    },

    updateGift: function () {
        if (this.message.isGiftMessage() && !this.message.isUserMessage() && this.collectGiftButton) {
            if (this.message.gift && !this.message.gift.isReceived()) {
                this.collectGiftButton.enable();
            } else {
                this.collectGiftButton.disable();
            }
            cleverapps.toolbar.resetByType(ToolbarItem.CLANS);
        }
    },

    createContentToReceiveHelp: function () {
        const styles = cleverapps.styles.ClanMessageRow.teammateHelp;

        const bar = this.createProgressBar();

        this.helpButtons = [];

        const helpList = this.message.listHelp().filter((help) => help.status !== ClansConfig.HELP_RECEIVED).map(function (help) {
            const bg = cleverapps.UI.createScale9Sprite(bundles.my_clan_window.frames.massage_help_from_teammates_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
            bg.setContentSize2(styles);

            const title = this.createTitle(help.senderAvatar, help.getSenderName());

            const button = this.createHelpButton(Messages.get("Claim"), () => {
                cleverapps.clanMessages.collectHelp(help, button);
            });
            button.help = help;
            this.helpButtons.push(button);

            const content = new cleverapps.Layout([title, button], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.margin
            });

            bg.addChild(content);
            content.setAlignment(styles.content);

            const node = new cc.Node();
            node.setAnchorPoint(0.5, 0.5);
            node.setContentSize2(bg.getContentSize());
            node.addChild(bg);
            bg.setAlignment(node.width / 2 + styles.offsetX, node.height / 2);

            return node;
        }, this);

        return new cleverapps.Layout([bar].concat(helpList), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.verticalMargin
        });
    },

    createContentToSendHelp: function () {
        const styles = cleverapps.styles.ClanMessageRow;

        const bar = this.createProgressBar();

        const button = this.sendHelpButton = this.createHelpButton(Messages.get("ClanMessage.helpButton"), () => {
            cleverapps.clanMessages.sendHelp(this.message.messageId, connector.platform.getUserID());
        });

        return new cleverapps.Layout([bar, button], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.content.margin
        });
    },

    createGiftIcon: function () {
        return new cc.Sprite(bundles.clan.frames.clan_gift);
    },

    createContentAboutSentGift: function () {
        const styles = cleverapps.styles.ClanMessageRow;

        const message = ClansConfig.MESSAGES[this.message.type].sender;
        const text = cleverapps.UI.generateOnlyText(Messages.get(message), cleverapps.styles.FONTS.CLAN_CHAT_PHRASE);
        const gift = this.createGiftIcon();

        const layout = new cleverapps.Layout([text, gift], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.giftMessage.margin
        });

        cleverapps.UI.fitToBox(layout, {
            width: styles.width
        });

        return layout;
    },

    createContentToGetGift: function () {
        const styles = cleverapps.styles.ClanMessageRow;

        const message = ClansConfig.MESSAGES[this.message.type].receiver;
        const text = cleverapps.UI.generateOnlyText(Messages.get(message), cleverapps.styles.FONTS.CLAN_CHAT_TEAMMATE_PHRASE);

        const gift = this.createGiftIcon();

        let button;
        if (this.message.gift) {
            button = this.collectGiftButton = this.createGiftButton(Messages.get("ClanMessage.claimGiftButton"), () => {
                cleverapps.clanMessages.collectGift(this.message.gift, button);
            });
        }

        return new cleverapps.Layout([text, gift, button].filter(Boolean), {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.giftMessage.margin
        });
    },

    createTitle: function (avatar, name, type) {
        const styles = cleverapps.styles.ClanMessageRow;

        const userAvatar = new cleverapps.UI.Avatar(avatar);
        cleverapps.UI.fitToBox(userAvatar, {
            height: styles.title.avatar.height
        });
        const userName = cleverapps.UI.generateOnlyText(`${name}:`, cleverapps.styles.FONTS.CLAN_CHAT_USERNAME_TEXT);
        userName.fitTo(type === undefined ? styles.teammateHelp.name.width : styles.title.name.width);

        let text = "";
        if (type === undefined) {
            text = "ClanMessage.helpYou";
        } else if (type === ClansConfig.MESSAGE_TYPE_ENERGY) {
            text = "ClanMessage.sendEnergy";
        }
        const msg = cleverapps.UI.generateOnlyText(Messages.get(text), cleverapps.styles.FONTS.BUTTON_TEXT);
        msg.fitTo(type === undefined ? styles.teammateHelp.helpText.width : styles.title.helpText.width);

        return new cleverapps.Layout([userAvatar, userName, msg], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.title.margin
        });
    },

    createProgressBar: function () {
        const styles = cleverapps.styles.ClanMessageRow;

        const totalHelp = this.message.getTotalHelp();
        const currentHelp = this.message.getCurrentHelp();

        const bar = this.bar = new ScaledProgressBar({
            progress: bundles.my_clan_window.frames.bar_clanwindow,
            background: bundles.my_clan_window.frames.bg_clanwindow
        });
        bar.setLength(styles.content.bar.width);
        bar.setGoal(totalHelp);
        bar.setPercentage(currentHelp);

        if (cleverapps.config.debugMode) {
            cleverapps.UI.onClick(bar, () => {
                const restricted = [this.message.playerId].concat(this.message.helps.map((help) => help.senderId));

                const sender = cleverapps.userClan.players.find((player) => restricted.indexOf(player.id) === -1);

                if (sender) {
                    cleverapps.clanMessages.sendHelp(this.message.messageId, sender.id);

                    if (this.message.isUserMessage()) {
                        cleverapps.focusManager.closeAllWindows();

                        cleverapps.focusManager.display({
                            focus: "MyClanWindow",
                            stack: true,
                            action: function (f) {
                                new MyClanWindow();
                                cleverapps.focusManager.onceNoWindowsListener = f;
                            }
                        });
                    }
                }
            });
        }

        const icon = new cc.Sprite(cleverapps.skins.getSlot("energy_icon_png") || bundles.buttons_inlined_icons.frames.energy_icon_png);
        icon.setAlignment(styles.content.bar.icon);
        bar.addChild(icon);

        const barText = this.barText = cleverapps.UI.generateImageText(`${currentHelp}/${totalHelp}`, cleverapps.styles.FONTS.SMALL_WHITE_TEXT);
        barText.setAnchorPoint(0.5, 0.5);
        barText.setPosition(bar.width / 2, bar.height / 2);
        bar.addChild(barText);

        return bar;
    },

    updateProgressBar: function (silent) {
        const totalHelp = this.message.getTotalHelp();
        const currentHelp = this.message.getCurrentHelp();

        this.barText.setString(`${currentHelp}/${totalHelp}`);

        this.bar.setGoal(totalHelp);
        this.bar.setPercentage(currentHelp, {
            animated: !silent
        });

        if (!silent) {
            this.barText.runAction(new cc.Sequence(
                new cc.ScaleTo(0.2, 1.1),
                new cc.ScaleTo(0.2, 1)
            ));
        }
    },

    createHelpButton: function (actionText, onClick) {
        const styles = cleverapps.styles.ClanMessageRow;

        const action = cleverapps.UI.generateOnlyText(actionText, cleverapps.styles.FONTS.BUTTON_TEXT);
        const icon = new cc.Sprite(cleverapps.skins.getSlot("energy_icon_png") || bundles.buttons_inlined_icons.frames.energy_icon_png);
        const amount = cleverapps.UI.generateOnlyText(`x${this.message.getHelpAmount()}`, cleverapps.styles.FONTS.BUTTON_TEXT);
        const content = new cleverapps.Layout([action, icon, amount], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.content.button.margin
        });

        return new cleverapps.UI.Button({
            type: styles.content.button.type,
            content,
            width: styles.content.button.width,
            height: styles.content.button.height,
            onClicked: function () {
                onClick();
            }
        });
    },

    createGiftButton: function (actionText, onClick) {
        const styles = cleverapps.styles.ClanMessageRow;
        actionText = this.message.gift && !this.message.gift.isReceived() ? actionText : Messages.get("ClanMessage.giftClaimed");
        const action = cleverapps.UI.generateOnlyText(actionText, cleverapps.styles.FONTS.BUTTON_TEXT);
        if (this.message.gift && !this.message.gift.isReceived()) {
            const icon = new cc.Sprite(bundles.buttons_inlined_icons.frames.coin_icon_png);
            const amount = cleverapps.UI.generateOnlyText(`x${this.message.gift.getGiftAmount()}`, cleverapps.styles.FONTS.BUTTON_TEXT);
            const content = new cleverapps.Layout([action, icon, amount], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.content.button.margin
            });

            return new cleverapps.UI.Button({
                type: styles.content.button.type,
                content,
                width: styles.content.button.width,
                height: styles.content.button.height,
                onClicked: function () {
                    onClick();
                }
            });
        }

        return new cleverapps.UI.Button({
            type: styles.content.button.type,
            content: action,
            width: styles.content.button.width,
            height: styles.content.button.height,
            onClicked: function () {
                onClick();
            }
        });
    },

    addArrow: function (container) {
        let styles = cleverapps.styles.ClanMessageRow.arrow;
        let image;

        if (this.message.isUserMessage()) {
            styles = styles.right;
            image = bundles.my_clan_window.frames.massage_orange_arrow;
        } else {
            styles = styles.left;
            image = bundles.my_clan_window.frames.massage_arrow;
        }

        const icon = new cc.Sprite(image);
        container.addChild(icon);

        icon.setAlignment(styles);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CLAN_CHAT_TEAMMATE_PHRASE: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    CLAN_CHAT_PHRASE: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    CLAN_CHAT_USERNAME_TEXT: {
        size: 36,
        color: cleverapps.styles.COLORS.YELLOW_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    CLANS_CHAT_TIMER_TEXT: {
        size: 28,
        color: cleverapps.styles.COLORS.YELLOW_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.ClanMessageRow = {
    width: 1190,
    deltaWidth: 100,
    maxRowWidth: 1000,
    helpRowWidth: 1000,

    left: {
        x: { align: "left" },
        y: { align: "center" }
    },

    right: {
        x: { align: "right" },
        y: { align: "center" }
    },

    arrow: {
        left: {
            x: { align: "left", dx: -26 },
            y: { align: "top", dy: -80 }
        },
        right: {
            x: { align: "right", dx: 29 },
            y: { align: "top", dy: -80 }
        }
    },

    title: {
        x: { align: "left", dx: 30 },
        y: { align: "center" },
        margin: 20,

        bg: {
            height: 80,
            x: { align: "left" },
            y: { align: "top" }
        },

        avatar: {
            height: 60
        },

        name: {
            width: 250
        },

        helpText: {
            width: 380
        },

        timer: {
            x: { align: "right", dx: -30 },
            y: { align: "center" }
        }
    },

    content: {
        margin: 50,
        x: { align: "center" },
        y: { align: "center", dy: -30 },

        bg: {
            paddingY: 140,
            x: { align: "left" },
            y: { align: "top" }
        },

        bar: {
            width: 350,

            icon: {
                x: { align: "left", dx: -5 },
                y: { align: "center", dy: 5 }
            }
        },

        button: {
            width: 240,
            height: 80,
            margin: 5,
            type: cleverapps.styles.UI.Button.Images.button_green
        }
    },

    phrase: {
        x: { align: "left", dx: 50 },
        y: { align: "center", dy: -30 }
    },

    teammateHelp: {
        width: 870,
        height: 100,
        verticalMargin: 10,
        margin: 50,
        offsetX: 58,

        content: {
            x: { align: "left", dx: 20 },
            y: { align: "center" }
        },

        name: {
            width: 220
        },

        helpText: {
            width: 190
        }
    },

    giftMessage: {
        margin: 15
    }
};
